import React, { ReactNode } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { ResponsiveSpacingType } from '@fiverr-private/theme/src/components/Box/types';
import { DisplayFromValue } from '../../shared/constants';

interface NavProps {
    children: ReactNode;
    gap?: ResponsiveSpacingType;
    displayFrom?: DisplayFromValue;
}

export const Nav = ({ gap = '1', children, displayFrom }: NavProps) => (
    <Stack as="nav" hidden={{ default: false, ...(displayFrom && { default: true, [displayFrom]: false }) }}>
        <Stack as="ul" gap={gap}>
            {children}
        </Stack>
    </Stack>
);
